import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || process.env.REACT_APP_API_URL || 'http://localhost:5002';
const socket = io(SOCKET_URL);

export const connectSocket = (userId) => {
  socket.emit('register', userId);

  socket.on('notification', (notification) => {
    console.log('New notification:', notification);
  });

  return socket;
};

export default socket;
